import React from "react";
import T from "prop-types";
import { StatusTag } from "MODULES/shared/components";

function Consignment({ lineItems }) {
  const consignmentType = lineItems.find(l => l.inventory.consignment_type);

  if (consignmentType) {
    return (
      <StatusTag
        key="consignment"
        display="warning"
        title={consignmentType.inventory.consignment_type.toUpperCase()}
        icon="location-arrow"
      />
    );
  }

  const consigned = lineItems.find(l => l.inventory.consigned_date);

  if (consigned) {
    return (
      <StatusTag
        key="consignment"
        display="warning"
        title="Consignment"
        icon="location-arrow"
      />
    );
  }

  return null;
}

Consignment.propTypes = {
  salesOrder: T.shape({})
};

export default Consignment;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Warnings/Consignment.jsx